import type { RoomTagRowsControl } from "building-types/rooms/roomTag";

export function isCeilingHeightShownForRoomTag(roomInstance: RoomTagRowsControl, floorPlanSetting: RoomTagRowsControl) {
  return !(
    !roomInstance.addCeilingHeightToRoomTag &&
    !(roomInstance.addCeilingHeightToRoomTag === undefined && floorPlanSetting.addCeilingHeightToRoomTag)
  );
}

export function isFloorMaterialShownForRoomTag(roomInstance: RoomTagRowsControl, floorPlanSetting: RoomTagRowsControl) {
  // This complicated logic is to handle the case where the roomInstance.addFloorMaterialToRoomTag is undefined
  return !(
    !roomInstance.addFloorMaterialToRoomTag &&
    !(roomInstance.addFloorMaterialToRoomTag === undefined && floorPlanSetting.addFloorMaterialToRoomTag)
  );
}
